import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { CreatedGateway } from '../gateway-setup.service';
import { Location } from '../../locations/location.service';

@Component({
  selector: 'app-gateway-list',
  templateUrl: './gateway-list.component.html',
  styleUrls: ['./gateway-list.component.scss']
})
export class GatewayListComponent implements OnInit, OnChanges {
  @Input() gateways: Array<CreatedGateway>;
  @Input() locations: Array<Location>;

  visibleGateways: Array<CreatedGateway>;

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    // add a filter if users complain too messy, filter by gateway.status
    this.visibleGateways = this.gateways.sort(byExpireTimeDsc);
  }

  public formatTimestampToDate(timestamp) {
    return new Date(timestamp).toString().slice(0, 21);
  }

  public formatLocationToName(locationId) {
    const location = this.locations.find(l => l.location_id === locationId);
    if (location && location.location_name) {
      return location.location_name;
    }
    return 'Location not available to user';
  }
}

function byExpireTimeDsc(a: CreatedGateway, b: CreatedGateway): number {
  return b.expire_time - a.expire_time;
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/gateway-setup/gateway-list/gateway-list.component.ts